export default {
    pushState(stateData, title, url) {
        if (typeof history !== "undefined" && history.pushState) {
            if (url) {
                // IE is dumb and if url is undefined it'll actually change the url to undefined                
                history.pushState(stateData, title, url);
            } else {
                history.pushState(stateData, title);
            }
        }
    },

    replaceState(stateData, title, url) {
        if (typeof history !== "undefined" && history.replaceState) {
            if (url) {
                // IE is dumb and if url is undefined it'll actually change the url to undefined                
                history.replaceState(stateData, title, url);
            } else {
                history.replaceState(stateData, title);
            }
        }
    },

    addPopStateListener(listener) {
        if (typeof history !== "undefined" && history.pushState) {
            window.addEventListener("popstate", listener);
        }
    },

    removePopStateListener(listener) {
        if (typeof history !== "undefined" && history.pushState) {
            window.removeEventListener("popstate", listener);
        }
    },

    back() {
        if (typeof history !== "undefined" && history.back) {
            history.back();
        }
    }
};